import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { DetailsGroup } from 'app/components/Reports/_Subsidies/_common/useReportDetailsGroup'

export type DetailsGroupItem = {
  id: string
  title: string
}

type DetailsGroups = DetailsGroupItem[]

class DetailsGroupFilterDataBox extends DataBox<DetailsGroups> {}

const commonDetailsGroups: DetailsGroups = [
  { id: DetailsGroup.NoGroup, title: 'без группировки' },
  { id: DetailsGroup.ByAllowances, title: 'категориям льгот' },
  {
    id: DetailsGroup.ByAllowancesAndFoodModes,
    title: 'категориям льгот и режимам питания',
  },
]

const singleOrgDetailsGroups: DetailsGroups = [
  { id: DetailsGroup.ByStudents, title: 'пользователям и справкам' },
  { id: DetailsGroup.ByClasses, title: 'классам' },
  { id: DetailsGroup.ByClassesAndOrders, title: 'классам и справкам' },
]

export const getDetailsGroupData = (singleOrg: boolean): DetailsGroups => [
  ...commonDetailsGroups,
  ...(singleOrg ? singleOrgDetailsGroups : []),
]

export const defaultDetailsGroup: DetailsGroups = getDetailsGroupData(false)
export const detailsGroupFilter = createDataBox(
  'detailsGroupFilter',
  defaultDetailsGroup,
  DetailsGroupFilterDataBox,
)
detailsGroupFilter.setStatusReady()

export const defaultDetailsGroupSelection: DetailsGroup = DetailsGroup.NoGroup
export const detailsGroupFilterSelection = createDataBoxDefault<string>(
  'detailsGroupFilterSelection',
  defaultDetailsGroupSelection,
)
